<template>
  <div class="vue-full-cal-event-panel">
    <transition name="zoomIn">
      <DCalendarShowEvent
        v-if="eventId"
        :isInitEventLoading="!event || isEventsLoading"
        :event="event"
        :initCalendarId="calendarId"
        @submitDeleteEventOnward="onEventUpdated"
        @close="onClose"
        @updated="onEventUpdated">
      </DCalendarShowEvent>
    </transition>
  </div>
</template>
<script>
import DCalendarShowEvent from '../DCalendar/DCalendarShowEvent'
import moment from 'moment'
import docendo from '../../docendo'
import Loader from '../common/Loader'

export default {
  components: {Loader, DCalendarShowEvent},
  data () {
    return {
      calendarId: null,
      eventId: null,
      events: [],
      isEventsLoading: false
    }
  },
  computed: {
    event () {
      const idx = this.events.findIndex(event => event.event_id === this.eventId)
      return idx > -1 ? this.events[idx] : null
    }
  },
  methods: {
    onEventUpdated () {
      // Native event for Full Calendar
      const customEvent = new window.CustomEvent('UpdateCalendarEvents', {bubbles: true, cancelable: true})
      window.document.dispatchEvent(customEvent)
    },
    onClose () {
      this.eventId = null
    },
    readEvents (event) {
      this.calendarId = event.calendar_id
      this.eventId = event.event_id
      const obj = {
        calIds: [this.calendarId],
        start: moment(event.start).format('YYYY-MM-DD 00:00'),
        end: moment(event.end).endOf('day')
      }
      this.isEventsLoading = true
      docendo.calendarEvents2(obj.calIds, obj.start, obj.end, null,
        data => {
          console.log({data})
          this.isEventsLoading = false
          this.events = data.length > 0 ? JSON.parse(data) : []
        }, failure => {
          console.log('failure', failure)
        })
    },
    eventHandler (e) {
      const event = e.detail['calEvent']
      this.readEvents(event)
    }
  },
  mounted () {
    window.removeEventListener('fullcal_event_click_for_vue', this.eventHandler)
    window.addEventListener('fullcal_event_click_for_vue', this.eventHandler)
  },
  beforeDestroy () {
    window.removeEventListener('fullcal_event_click_for_vue', this.eventHandler)
  }
}
</script>



// WEBPACK FOOTER //
// DShowEventFullCal.vue?3be1d350